import { CATALYST_COLORS_WITH_HEXCODES } from "../../constants/styles";
import type { SelectOption } from "../Select";
import { ColorOption } from "./StandardTagColorOption";

export const STANDARD_TAG_COLORS = {
  Teal: {
    textColor: "var(--colors-teal-600)",
    backgroundColor: "var(--colors-teal-200)",
    bgHexcode: CATALYST_COLORS_WITH_HEXCODES.TEAL_200
  },
  Red: {
    textColor: "var(--colors-red-600)",
    backgroundColor: "var(--colors-red-200)",
    bgHexcode: CATALYST_COLORS_WITH_HEXCODES.RED_200
  },
  Green: {
    textColor: "var(--colors-green-600)",
    backgroundColor: "var(--colors-green-200)",
    bgHexcode: CATALYST_COLORS_WITH_HEXCODES.GREEN_200
  },
  Purple: {
    textColor: "var(--colors-purple-600)",
    backgroundColor: "var(--colors-purple-200)",
    bgHexcode: CATALYST_COLORS_WITH_HEXCODES.PURPLE_200
  },
  Orange: {
    textColor: "var(--colors-orange-600)",
    backgroundColor: "var(--colors-orange-200)",
    bgHexcode: CATALYST_COLORS_WITH_HEXCODES.ORANGE_200
  },
  Blueberry: {
    textColor: "var(--colors-blueberry-400)",
    backgroundColor: "var(--colors-blueberry-200)",
    bgHexcode: CATALYST_COLORS_WITH_HEXCODES.BLUEBERRY_200
  },
  Pink: {
    textColor: "var(--colors-pink-400)",
    backgroundColor: "var(--colors-pink-100)",
    bgHexcode: CATALYST_COLORS_WITH_HEXCODES.PINK_100
  },
  Brick: {
    textColor: "var(--colors-brick-400)",
    backgroundColor: "var(--colors-brick-100)",
    bgHexcode: CATALYST_COLORS_WITH_HEXCODES.BRICK_100
  },
  Blue: {
    textColor: "var(--colors-blue-400)",
    backgroundColor: "var(--colors-blue-100)",
    bgHexcode: CATALYST_COLORS_WITH_HEXCODES.BLUE_100
  },
  Grey: {
    textColor: "var(--colors-neutral-750)",
    backgroundColor: "var(--colors-neutral-300)",
    bgHexcode: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_300
  }
} as const;

export const STANDARD_TAG_COLOR_OPTIONS: SelectOption[] = Object.entries(
  STANDARD_TAG_COLORS
).map(([key, value]) => ({
  value: key,
  label: (
    <ColorOption
      label={key}
      textColor={value.textColor}
      backgroundColor={value.backgroundColor}
    />
  )
}));
